import { Variants } from "framer-motion";

export const transitions = {
  easeAll: "0.5s ease all",
  hover: "all 125ms ease-in-out",
};

export const scoreTransitionDurationMS = 1500;

export const slideDown: Variants = {
  initial: {
    height: 0,
    overflow: "hidden",
  },
  animate: {
    height: "auto",
    transition: {
      height: {
        duration: 0.3,
      },
    },
  },
  exit: {
    height: 0,
    overflow: "hidden",
    transition: {
      height: {
        duration: 0.3,
      },
    },
  },
};

export const addressesVariants: Variants = {
  initial: {
    y: "-20px",
    x: "-50%",
    opacity: 0,
  },
  animate: {
    y: "0",
    x: "-50%",
    opacity: 1,
    transition: {
      duration: 0.3,
      type: "spring",
      damping: 25,
      stiffness: 500,
    },
  },
  exit: {
    y: "20px",
    x: "-50%",
    opacity: 0,
    transition: {
      duration: 0.2,
    },
  },
};
